import { Image } from 'antd'
import './OrderHeroPanel.style.less'
import buyerIcon from '@/assets/images/order-icon/buyer.svg'
import factoryIcon from '@/assets/images/order-icon/factory.svg'
import locationIcon from '@/assets/images/order-icon/location.svg'
import qtyIcon from '@/assets/images/order-icon/qty.svg'
import dateIcon from '@/assets/images/order-icon/date.svg'
import { find } from 'lodash'
import { numberWithCommas } from '@/utils/common'
import moment from 'moment'
import { useEffect, useState } from 'react'
import Fade from '@/components/Fade'
import { IMG_PLACE_HOLDER } from '@/constant/common'
import { transfromTotalOrder } from '../../../ViewOrder/ViewOrder.transform'
import { useAuth } from '@/providers/auth.provider'
import { IsAdminRole } from '@/utils/users'
import AvatarGroup from '../TimeAndAction/components/TimeActionHeroPanel/AvatarGroup'
import {
  ACTING_ROLE_ADMIN,
  ActingUserRole,
  COLLABORATOR_ROLE_OWNER,
  COLLABORATOR_ROLE_VIEWER,
} from '../../../Order.constant'
import InvitePeopleModal from './InvitePeopleModal'

type Props = {
  data: any
  collaborators?: any[]
  onCollaboratorsUpdate?: () => void
}

function OrderHeroPanel(props: Props) {
  const { data, collaborators = [], onCollaboratorsUpdate } = props
  const { user } = useAuth()
  const [totalOrder, settotalOrder] = useState(0)
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    settotalOrder(
      transfromTotalOrder(
        data?.product_details?.order_quantity?.value,
        data?.product_details?.quantity_breakdown?.value
      )
    )
  }, [])

  const isWorkspaceAdmin = IsAdminRole(user)

  const displayCollaborators =
    collaborators.length > 0
      ? collaborators
      : data?.created_by
      ? [
          {
            user: data.created_by,
            roles: { role: COLLABORATOR_ROLE_OWNER },
          },
        ]
      : []

  const currentUserCollab = displayCollaborators.find((c) => c?.user?.id === user?.id)

  const actingUserRole: ActingUserRole = isWorkspaceAdmin
    ? ACTING_ROLE_ADMIN
    : currentUserCollab?.roles?.role ??
      (data?.created_by?.id === user?.id
        ? COLLABORATOR_ROLE_OWNER
        : COLLABORATOR_ROLE_VIEWER)

  const picture = data?.picture?.url_path ?? ''
  const buyer = find(
    data?.property_value?.values,
    (item) => item.field == 'buyer'
  )?.value
  const supplier = find(
    data?.property_value?.values,
    (item) => item.field == 'supplier'
  )?.value
  const number = data?.number
  const date = data?.to_be_delivered_date
  const quantity = totalOrder
  const country = find(
    data?.property_value?.values,
    (item) => item.field == 'country'
  )?.value

  return (
    <Fade>
      <div className="order-hero-panel-container">
        <Image
          className="order-image"
          src={picture}
          fallback={IMG_PLACE_HOLDER}
          preview={{ maskClassName: 'order-preview-image-mask' }}
        />
        <div className="text-container">
          <p className="order-number">Order no. {number}</p>
          <div className="detail-container">
            {buyer && (
              <div className="detail-item">
                <img src={buyerIcon} />
                <p>{buyer}</p>
              </div>
            )}
            {supplier && (
              <div className="detail-item">
                <img src={factoryIcon} />
                <p>{supplier}</p>
              </div>
            )}

            {country && (
              <div className="detail-item">
                <img src={locationIcon} />
                <p>{country}</p>
              </div>
            )}
            {quantity != 0 && (
              <div className="detail-item">
                <img src={qtyIcon} />
                <p>{numberWithCommas(quantity)}</p>
              </div>
            )}
            <div className="detail-item">
              <img src={dateIcon} />
              <p>{moment(date).format('DD MMM YYYY')}</p>
            </div>
          </div>
        </div>

        <div style={{ marginLeft: 'auto', alignSelf: 'flex-start' }}>
          <AvatarGroup
            data={displayCollaborators}
            actingUserRole={actingUserRole}
            onAddClick={() => setModalOpen(true)}
          />
          {modalOpen && (
            <InvitePeopleModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              collaborators={collaborators}
              order={data}
              actingUserRole={actingUserRole}
              isWorkspaceAdmin={isWorkspaceAdmin}
              onUpdate={onCollaboratorsUpdate}
            />
          )}
        </div>
      </div>
    </Fade>
  )
}

export default OrderHeroPanel
